/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Dashboard
 *| (C) Copyright IBM Corp. 2019
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */

define(function() {
	'use strict';

	/**
	 * @return the JSON-like object for use in the query (stripped of attributes not relevant to query)
	 */

	class CollectionToQueryJSON {
		toQueryJSON (){
			let collectionQueryJSON = this.map((model) => model.toQueryJSON());
			return collectionQueryJSON;
		}
	}

	return CollectionToQueryJSON;
});
